<p-confirmDialog [visible]="open" [draggable]="false" styleClass="w-[31.25rem]">
  <ng-template pTemplate="header">
    <app-typography variant="header" color="white">{{ title }}</app-typography>
  </ng-template>

  <ng-template pTemplate="message">
    <div class="py-4">
      <ng-content></ng-content>
    </div>
  </ng-template>

  <ng-template pTemplate="footer" class="p-0">
    <div class="flex justify-end">
      <app-button
        label="{{ cancelButtonLabel }}"
        (sendClick)="onCancelClick($event)"
      />
      <app-button
        label="{{ confirmButtonLabel }}"
        (sendClick)="onConfirmationClick($event)"
      />
    </div>
  </ng-template>
</p-confirmDialog>
